import type { Reminder } from '@/core/domain';
import type { ReminderRepository } from '../repositories/reminder-repository';

export interface GetAllRemindersOptions {
  forceRefresh?: boolean;
}

export class GetAllRemindersUseCase {
  constructor(private readonly repository: ReminderRepository) {}

  execute(userId: string, options?: GetAllRemindersOptions): Promise<Reminder[]> {
    return this.repository.getAll(userId, options?.forceRefresh === true);
  }
}
